<ion-app>
  <ion-split-pane contentId="main">
    <ion-router-outlet id="main"></ion-router-outlet>
    <ion-menu contentId="main" type="overlay" class="my-custom-menu">
      <ion-content>
        <div class="menu-hero">
          <img
            src="assets/imgs/universal-plant-services.svg"
            alt="Universal Plant Services"
            class="menu-logo"
          />
          <div class="menu-title">UPS App Store</div>
          <div class="menu-meta">
            <!-- <span class="menu-version">{{ version }}</span> -->
            @if (!environment.production) {
              <span class="menu-env">
                {{ environment.environment_name.toUpperCase() }}
              </span>
            }
          </div>
        </div>

        <ion-list id="side-drawer">
          <ion-menu-toggle auto-hide="false">
            <ion-item button (click)="showApps()">
              <ion-icon
                slot="start"
                [ios]="'phone-portrait-outline'"
              ></ion-icon>
              <ion-label>Applications</ion-label>
            </ion-item>
            <ion-item button (click)="showHelp()">
              <ion-icon slot="start" [ios]="'help-circle-outline'"></ion-icon>
              <ion-label>Help</ion-label>
            </ion-item>
            <ion-item button (click)="logout()">
              <ion-icon
                slot="start"
                [ios]="'log-out-outline'"
                [md]="'log-out-sharp'"
              ></ion-icon>
              <ion-label>Logout</ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list>
      </ion-content>
    </ion-menu>
  </ion-split-pane>
</ion-app>
